import script from "./EDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./EDialog.vue?vue&type=script&setup=true&lang=ts"

import "./EDialog.vue?vue&type=style&index=0&id=2b18fb99&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2b18fb99"]])

export default __exports__